module.exports = __webpack_public_path__ + "static/media/ImgNoChat.e8f0ecce.png";